import { useState } from 'react';

export function SiteAdminUserDetailNotifications(props: any) {
  const { user } = props;
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <>
      <h2>
        <a
          href="#"
          className="alt-button"
          onClick={(e) => {
            e.preventDefault();
            setShowNotifications(!showNotifications);
          }}
        >
          <span>
            {showNotifications ? '-' : '+'} Notifications ({user.notifications.length})
          </span>
        </a>
      </h2>

      {showNotifications && (
        <article>
          <div>
            <table>
              <thead>
                <tr>
                  <th scope="col">Next Reminder (UTC)</th>
                  <th scope="col">Reminder(s) since last study</th>
                </tr>
              </thead>
              <tbody>
                {user.leStudyHabit ? (
                  <tr>
                    <td>{user.leStudyHabit.nextReminder}</td>
                    <td>{user.leStudyHabit.remindersSinceLastStudy}</td>
                  </tr>
                ) : (
                  <tr>
                    <td>Nothing here yet</td>
                    <td>Nothing here yet</td>
                  </tr>
                )}
              </tbody>
            </table>

            {user.notifications.length > 0 && (
              <table>
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Notification</th>
                    <th scope="col">Type</th>
                    <th scope="col">Created at</th>
                    <th scope="col">Delivered at</th>
                    <th scope="col">Failed at</th>
                    <th scope="col">Data</th>
                  </tr>
                </thead>
                <tbody>
                  {user.notifications.map((notification) => (
                    <tr key={notification.id}>
                      <td>{notification.id}</td>
                      <td>{notification.notificationType}</td>
                      <td>{notification.rpushNotificationType}</td>
                      <td>{notification.createdAt}</td>
                      <td>{notification.rpushNotification?.deliveredAt || 'N/A'}</td>
                      <td>{notification.rpushNotification?.failedAt || 'N/A'}</td>
                      <td>{JSON.stringify(notification.rpushNotification?.data)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </article>
      )}
    </>
  );
}
